import { render } from "./guidearticlecard.vue?vue&type=template&id=9c3d1bf4"
import script from "./guidearticlecard.js?vue&type=script&lang=js"
export * from "./guidearticlecard.js?vue&type=script&lang=js"

import "./guidearticlecard.vue?vue&type=style&index=0&id=9c3d1bf4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__